export default function Loading() {
  return (
    <div className="loading">
      <span className="spinner" aria-hidden="true" />
      <span>Yükleniyor...</span>
    </div>
  )
}
